module.exports = __webpack_public_path__ + "img/share-2_1.aac294e3.svg";